<template>
    <section class="welcomeSection assessmentSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="hideOnDesktop">
                <img src="/img/adt-stop-sign.png" class="welcomeStopSign-mobile" alt="ADT stop sign" />
            </div>
            <div class="pageTitle">
                <span v-if="newUser">Hello! </span>
                <span v-if="!newUser">Welcome back! </span> 
                We are going to help secure your home.
                <br> Let’s
                <span v-if="newUser">get started?</span>
                <span v-if="!newUser">continue.</span>
            </div>
            <div class="welcomeColumns">
                <div class="welcomeColumn">
                    <div class="pageText">
                        <p>
                            {{ '<' }} 10 minutes, Free quote, Professional guidance and huge savings
                        </p>
                    </div>
                    <div class="welcomeInputs">
                        <FormInput placeholder="What's your name?"
                                    :value="lead.name"
                                    leadKey="name" />
                        <FormInput placeholder="What's your email?"
                                    :value="lead.email"
                                    leadKey="email" />
                        <!-- <FormInput
                            placeholder="What's your phone number?"
                            type="tel"
                            mask="(###) ###-####"
                            :value="lead.phone"
                            leadKey="phone" /> -->
                    </div>
                    <continue-button to="/assessment/protection-level-overview"
                                     :after="addUserDataToMixpanel"
                                     :text="continueButtonText" />
                    <div class="startOverSection">
                        <a 
                            href="/assessment/start-over"
                            onClick="mixpanel.track('startedOver')">
                                Clear data and start over
                        </a>
                    </div>
                </div>
                <div class="welcomeColumn">
                    <img src="/img/adt-stop-sign.png"
                         alt="ADT Stop sign">
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import FormInput from '../components/FormInput.vue'
export default {
    components: {
        FormInput
    },
    computed: {
        ...mapState(['lead', 'newUser', 'errors', 'uuid', 'user']),

        continueButtonText () {
            return this.newUser ? "Let's get started" : 'Continue'
        }
    },
    methods: {
        ...mapActions(['nextSection', 'updateEmail', 'updateName']),

        addUserDataToMixpanel () {
            let name = this.lead.name
            let email = this.lead.email.toLowerCase()
            let nameSplit = name.split(' ')
            let firstName = ''
            let lastName = ''

            if (nameSplit.length > 1) {
                firstName = nameSplit[0]
                lastName = nameSplit[1]
            }

            let userData = {
                $email: email,
                name: this.lead.name,
                phone: this.lead.phone,
                $first_name: firstName,
                $last_name: lastName
            }

            Intercom('update', {
                name: this.lead.name,
                email: email,
                phone: this.lead.phone,
                $adminUrl: window.appUrl + '/admin/leads/' + this.uuid
            });

            mixpanel.register({
                "email": email,
                "name": this.lead.name,
                "phone": this.lead.phone,
            });

            gtag('event', 'conversion', { 'send_to': 'AW-879819493/5lMrCNW8y3sQ5fXDowM' });

            axios.post('/ajax/handle-user-welcome', {
                mixpanelId: mixpanel.get_distinct_id(),
                intercomId: Intercom('getVisitorId'),
            })
                .then((res) => {
                    const leadIsNew = res.isNew
                    if (!leadIsNew) {
                        mixpanel.identify(email)
                    } else {
                        mixpanel.alias(email)
                    }
                    mixpanel.track("signedUp")
                    mixpanel.people.set(userData)
                })
        }
    },
    mounted () {
        mixpanel.track('startedApp')
        this.$Progress.set(7)
        gtag('event', 'conversion', { 'send_to': 'AW-879819493/SxfeCO604nsQ5fXDowM' });
    }
}
</script>

<style lang="css">

</style>
